import { useSimulationBorderMarker } from '../hooks';
import { useTimelineStore } from '../../Gantt/store';

type SimulationRangeProps = {
  startDate: Date;
  planningBoundaryDate?: Date;
};

export const SimulationRange = ({ startDate }: SimulationRangeProps) => {
  const currentFilter = useTimelineStore((state) => state.filters.current);

  const simMarker = useSimulationBorderMarker(startDate, currentFilter.measureScale);

  if (!simMarker.isVisible) {
    return null;
  }

  return (
    <>
      <div className="absolute top-0 bottom-0 z-5000" style={{ left: simMarker.toPublishBoundaryLeftDistance }}>
        <div className="h-full w-[3px] bg-border-status-orange opacity-30"></div>
      </div>
      <div className="absolute top-0 bottom-0 z-5000" style={{ left: simMarker.freezeBoundaryLeftDistance }}>
        <div className="h-full w-[3px] bg-border-status-navy-darker opacity-30"></div>
      </div>
    </>
  );
};
